import Application from "./Application";
import common from "./common";
import definitions from "./definitions";
import CNPreloaderScene from "./scenes/CNPreloaderScene";
import {json} from "p3";
import settings from "./settings";
import Tracking from "./utils/Tracking";
import Ads from "./utils/Ads";

export default class Main {
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
        this._startReady = false;
    }

    init() {
        settings.APP = IS_APP == true ? true : settings.APP;

        PIXI.settings.MIPMAP_TEXTURES = false;
        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        PIXI.settings.STRICT_TEXTURE_CACHE = true;

        P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 = false;
        P3.settings.WARN_TEXTURE_MISSING = true;

        common.STAGE_HALF_WIDTH = common.STAGE_WIDTH * 0.5;
        common.STAGE_HALF_HEIGHT = common.STAGE_HEIGHT * 0.5;

        common.tracking = new Tracking("IvandoeQuestOn", "ivandoe quest on");
        common.ads = new Ads();

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true,
            onLoadLegacy: false,
            onResizeLegacy: false,
            rotateImageUrl: "assets/images/rotate_device_original.jpg",
        };

        // mutes the game when not in correct tab
        let hidden;
        "undefined" != typeof document.hidden ? (hidden = "hidden",
            this.visibilityChange = "visibilitychange")     : "undefined" != typeof document.mozHidden  ? (hidden = "mozHidden",
            this.visibilityChange = "mozvisibilitychange")  : "undefined" != typeof document.msHidden   ? (hidden = "msHidden",
            this.visibilityChange = "msvisibilitychange")   : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden",
            this.visibilityChange = "webkitvisibilitychange");

        document.addEventListener(this.visibilityChange, function() {
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
        }, false);

        const view = new P3.View(options);
        view.signals.ready.once((canvas) => {

            // root container will act as stage
            const stage = new PIXI.Container();
            common.stage = stage;

            // initialize default input manager with canvas reference for keyboard input
            const input = P3.input;
            input.init(stage, canvas);

            // note that width/height are defined here PIXI v5 onwards
            const options = {};
            options.width = this._width;
            options.height = this._height;
            options.view = canvas;
            options.antialias = false;
            options.resolution = 1;
            options.backgroundColor = 0x0;

            // initialize the PIXI renderer
            const renderer = PIXI.autoDetectRenderer(options);
            common.renderer = renderer;

            // we add the default scene managers view to the display list
            const scene = P3.scene;
            common.stage.addChild(scene.view);

            // we add our transitions to this to ensure they are always on top of everything
            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            // we stop the shared ticker that drives animation/rendering
            const ticker = PIXI.Ticker.shared;

            switch (common.config.ticker) {
                default:
                case "pixi": {

                    gsap.ticker.remove(gsap.updateRoot);

                    let elapsed = 0;

                    // update game accordingly
                    ticker.add((delta) => {
                        window.dt = delta / PIXI.settings.TARGET_FPMS / 1000;
                        elapsed += window.dt;

                        scene.update();
                        input.update();

                        gsap.updateRoot(elapsed);

                        renderer.render(stage);
                    });

                    break;
                }
                case "gsap": {

                    ticker.stop();
                    ticker.autoStart = false;

                    gsap.ticker.add(() => { ticker.update() });

                    // update game accordingly
                    ticker.add((delta) => {
                        window.dt = delta / PIXI.settings.TARGET_FPMS / 1000;

                        scene.update();
                        input.update();

                        renderer.render(stage);
                    });
                    break;
                }
            }

            var urlParams = new URLSearchParams(window.location.search);
            if(urlParams.get('vision') == 'true' || Number(urlParams.get('vision')) > 0 ) {
                common.visionOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
                common.visionOverlay.tint = 0x3b2d25;
                common.visionOverlay.width = common.STAGE_WIDTH;
                common.visionOverlay.height = common.STAGE_HEIGHT;
                common.visionOverlay.alpha = !isNaN(Number(urlParams.get('vision'))) ? Number(urlParams.get('vision')) : 0.3;
                common.visionOverlay.blendMode = PIXI.BLEND_MODES.MULTIPLY;
                common.stage.addChild(common.visionOverlay);
            }

            this.loadPreAssets();
        });
        view.signals.resize.add(this.onCanvasResize, this);

        this.loadConfig(() => {
            view.init();
        });
    }

    loadConfig(callback) {
        const basePath = "./";
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], basePath);
        P3.assets.signals.complete.once(function() {

            common.config = P3.assets.json("config");

            try {
                common.config.language = COUNTRY_CODE;
            }
            catch(e) {
                
            }

            var urlParams = new URLSearchParams(window.location.search);
            if(urlParams.get('language')){
                common.config.language = urlParams.get('language');
            }
            if(urlParams.get('immortal')){
                settings.IMMORTAL = urlParams.get('immortal') == 'false' ? false : true;
            }
            if(urlParams.get('tutorial')){
                settings.SKIP_TUTORIAL = urlParams.get('tutorial') == 'true' ? false : true;
            }

            callback && callback.call();
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        let files = [
            { name: "cn_preloader_1x", url: "images/cn_preloader_1x" + ".json" },
            { name: "locale", url: "data/localization/strings" + ".json" },
        ];

        if (files.length) {
            const basePath = "./";
            P3.assets.addFiles(files, basePath + "assets/");
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        let files = [
            { name: "ui_loader", url: "images/ui_loader" + ".jpg" },
            { name: "ui_loader_1x", url: "images/ui_loader_1x" + ".json" },

            { name: "loaders", url: "data/loaders" + ".json" },
            { name: "inventory", url: "data/inventory" + ".json" },
            { name: "shop", url: "data/shop" + ".json" },
            { name: "equipment", url: "data/equipment" + ".json" },
            { name: "ads", url: "data/ads" + ".json" },
            { name: "urls", url: "data/urls" + ".json" },

            { name: "alghera_60_generic", url: "fonts/alghera_60_generic" + ".xml" },       
            { name: "alghera_pro_languages", url: "fonts/alghera_pro_languages" + ".xml" },       
        ];

        let locations = [
            { name: "castle_dungeon", url: "data/locations/castle_dungeon/castle_dungeon" + ".json" },
            { name: "castle_exterior", url: "data/locations/castle_exterior/castle_exterior" + ".json" },
            { name: "cave_tunnels", url: "data/locations/cave_tunnels/cave_tunnels" + ".json" },
            { name: "cave_hidden_1", url: "data/locations/cave_hidden/1/cave_hidden_1" + ".json" },
            { name: "cave_hidden_2", url: "data/locations/cave_hidden/2/cave_hidden_2" + ".json" },
            { name: "cave_hidden_3", url: "data/locations/cave_hidden/3/cave_hidden_3" + ".json" },
            { name: "cave_hidden_4", url: "data/locations/cave_hidden/4/cave_hidden_4" + ".json" },
            { name: "cave_hidden_5", url: "data/locations/cave_hidden/5/cave_hidden_5" + ".json" },
            { name: "cave_hidden_6", url: "data/locations/cave_hidden/6/cave_hidden_6" + ".json" },
            { name: "cave_moles", url: "data/locations/cave_moles/cave_moles" + ".json" },
            { name: "forest_boariscamp", url: "data/locations/forest_boariscamp/forest_boariscamp" + ".json" },
            { name: "forest_clearing", url: "data/locations/forest_clearing/forest_clearing" + ".json" },
            { name: "forest_dark", url: "data/locations/forest_dark/forest_dark" + ".json" },
            { name: "forest_lakeside_east", url: "data/locations/forest_lakeside/east/forest_lakeside_east" + ".json" },
            { name: "forest_lakeside_west", url: "data/locations/forest_lakeside/west/forest_lakeside_west" + ".json" },
            { name: "forest_molecave", url: "data/locations/forest_molecave/forest_molecave" + ".json" },
            { name: "forest_outlaws", url: "data/locations/forest_outlaws/forest_outlaws" + ".json" },
            { name: "boggy_swamp", url: "data/locations/boggy_swamp/boggy_swamp" + ".json" },
            { name: "gnome_clearing", url: "data/locations/gnome_clearing/gnome_clearing" + ".json" },
            { name: "kingdom_stag", url: "data/locations/kingdom_stag/kingdom_stag" + ".json" },
            { name: "rocky_mountain", url: "data/locations/rocky_mountain/rocky_mountain" + ".json" },
            { name: "svan_land", url: "data/locations/svan_land/svan_land" + ".json" },
            { name: "tutorial", url: "data/locations/tutorial/tutorial" + ".json" },
            { name: "underwater_kingdom", url: "data/locations/underwater_kingdom/underwater_kingdom" + ".json" },
            { name: "village_farm", url: "data/locations/village_farm/village_farm" + ".json" }
        ];

        let characterJsons = [
            { name: "ivandoe", url: "data/characters/ivandoe" + ".json" },
            { name: "bert", url: "data/characters/bert" + ".json" },

            { name: "alan", url: "data/characters/alan" + ".json" },
            { name: "allan_the_dwarf", url: "data/characters/allan_the_dwarf" + ".json" },
            { name: "arthur", url: "data/characters/arthur" + ".json" },
            { name: "bobbin", url: "data/characters/bobbin" + ".json" },
            { name: "boar", url: "data/characters/boar" + ".json" },
            { name: "barry", url: "data/characters/barry" + ".json" },
            { name: "badger", url: "data/characters/badger" + ".json" },
            { name: "barbarian", url: "data/characters/barbarian" + ".json" },
            { name: "bar_keep", url: "data/characters/bar_keep" + ".json" },
            { name: "batwitch", url: "data/characters/batwitch" + ".json" },
            { name: "boaris", url: "data/characters/boaris" + ".json" },
            { name: "brian", url: "data/characters/brian" + ".json" },
            { name: "buff_sow", url: "data/characters/buff_sow" + ".json" },
            { name: "blind_moleman", url: "data/characters/blind_moleman" + ".json" },
            { name: "chef_sow", url: "data/characters/chef_sow" + ".json" },
            { name: "cupcake", url: "data/characters/cupcake" + ".json" },
            { name: "chick_of_doom", url: "data/characters/chick_of_doom" + ".json" },
            { name: "centicore", url: "data/characters/centicore" + ".json" },
            { name: "cedric", url: "data/characters/cedric" + ".json" },
            { name: "cyclops", url: "data/characters/cyclops" + ".json" },
            { name: "daisy", url: "data/characters/daisy" + ".json" },
            { name: "ditzi", url: "data/characters/ditzi" + ".json" },
            { name: "ducky", url: "data/characters/ducky" + ".json" },
            { name: "dwight", url: "data/characters/dwight" + ".json" },
            { name: "darklord", url: "data/characters/darklord" + ".json" },
            { name: "fish_guard", url: "data/characters/fish_guard" + ".json" },
            { name: "fox_thief_1", url: "data/characters/fox_thief_1" + ".json" },
            { name: "fox_thief_2", url: "data/characters/fox_thief_2" + ".json" },
            { name: "fox_thief_3", url: "data/characters/fox_thief_3" + ".json" },
            { name: "feral", url: "data/characters/feral" + ".json" },
            { name: "fritzi", url: "data/characters/fritzi" + ".json" },
            { name: "fish_monster", url: "data/characters/fish_monster" + ".json" },
            { name: "giant_spider", url: "data/characters/giant_spider" + ".json" },
            { name: "glitzi", url: "data/characters/glitzi" + ".json" },
            { name: "gunther", url: "data/characters/gunther" + ".json" },
            { name: "goblin", url: "data/characters/goblin" + ".json" },
            { name: "gnome_bear", url: "data/characters/gnome_bear" + ".json" },
            { name: "gregory", url: "data/characters/gregory" + ".json" },
            { name: "hansi", url: "data/characters/hansi" + ".json" },
            { name: "hench_cat_1", url: "data/characters/hench_cat_1" + ".json" },
            { name: "hench_cat_2", url: "data/characters/hench_cat_2" + ".json" },
            { name: "jezabel", url: "data/characters/jezabel" + ".json" },
            { name: "king_axalotyl", url: "data/characters/king_axalotyl" + ".json" },
            { name: "king_knut", url: "data/characters/king_knut" + ".json" },
            { name: "king_svanson", url: "data/characters/king_svanson" + ".json" },
            { name: "lars", url: "data/characters/lars" + ".json" },
            { name: "lisbet", url: "data/characters/lisbet" + ".json" },
            { name: "maggie", url: "data/characters/maggie" + ".json" },
            { name: "mr_fairy", url: "data/characters/mr_fairy" + ".json" },
            { name: "mother_duck", url: "data/characters/mother_duck" + ".json" },
            { name: "marjory", url: "data/characters/marjory" + ".json" },
            { name: "nanny", url: "data/characters/nanny" + ".json" },
            { name: "nobleswan_1", url: "data/characters/nobleswan_1" + ".json" },
            { name: "nobleswan_2", url: "data/characters/nobleswan_2" + ".json" },
            { name: "oskar", url: "data/characters/oskar" + ".json" },
            { name: "ogre_thief", url: "data/characters/ogre_thief" + ".json" },
            { name: "percy", url: "data/characters/percy" + ".json" },
            { name: "prince_svan", url: "data/characters/prince_svan" + ".json" },
            { name: "princess_svandelyne", url: "data/characters/princess_svandelyne" + ".json" },
            { name: "princess_syllabob", url: "data/characters/princess_syllabob" + ".json" },
            { name: "queen_grizabella", url: "data/characters/queen_grizabella" + ".json" },
            { name: "queen_kristine", url: "data/characters/queen_kristine" + ".json" },
            { name: "queen_svania", url: "data/characters/queen_svania" + ".json" },
            { name: "queen_moleworm", url: "data/characters/queen_moleworm" + ".json" },   
            { name: "raymond", url: "data/characters/raymond" + ".json" },
            { name: "rulf", url: "data/characters/rulf" + ".json" },
            { name: "roger", url: "data/characters/roger" + ".json" },
            { name: "rory", url: "data/characters/rory" + ".json" },
            { name: "spritzi", url: "data/characters/spritzi" + ".json" },
            { name: "suzie", url: "data/characters/suzie" + ".json" },            
            { name: "susan", url: "data/characters/susan" + ".json" },    
            { name: "stefan", url: "data/characters/stefan" + ".json" },         
            { name: "tatiana", url: "data/characters/tatiana" + ".json" },
            { name: "toby", url: "data/characters/toby" + ".json" },
            { name: "wolf", url: "data/characters/wolf" + ".json" },
            { name: "weasel", url: "data/characters/weasel" + ".json" },
        ];

        let characterInks = [
            { name: "alan.ink", url: "data/dialog/alan.ink" + ".json" },
            { name: "allan_the_dwarf.ink", url: "data/dialog/allan_the_dwarf.ink" + ".json" },
            { name: "arthur.ink", url: "data/dialog/arthur.ink" + ".json" },
            { name: "bobbin.ink", url: "data/dialog/bobbin.ink" + ".json" },
            { name: "boar.ink", url: "data/dialog/boar.ink" + ".json" },
            { name: "barry.ink", url: "data/dialog/barry.ink" + ".json" },
            { name: "badger.ink", url: "data/dialog/badger.ink" + ".json" },
            { name: "barbarian.ink", url: "data/dialog/barbarian.ink" + ".json" },
            { name: "bar_keep.ink", url: "data/dialog/bar_keep.ink" + ".json" },
            { name: "batwitch.ink", url: "data/dialog/batwitch.ink" + ".json" },
            { name: "boaris.ink", url: "data/dialog/boaris.ink" + ".json" },
            { name: "brian.ink", url: "data/dialog/brian.ink" + ".json" },
            { name: "buff_sow.ink", url: "data/dialog/buff_sow.ink" + ".json" },
            { name: "blind_moleman.ink", url: "data/dialog/blind_moleman.ink" + ".json" },
            { name: "cupcake.ink", url: "data/dialog/cupcake.ink" + ".json" },
            { name: "chef_sow.ink", url: "data/dialog/chef_sow.ink" + ".json" },
            { name: "chick_of_doom.ink", url: "data/dialog/chick_of_doom.ink" + ".json" },
            { name: "cedric.ink", url: "data/dialog/cedric.ink" + ".json" },
            { name: "centicore.ink", url: "data/dialog/centicore.ink" + ".json" },
            { name: "cyclops.ink", url: "data/dialog/cyclops.ink" + ".json" },
            { name: "daisy.ink", url: "data/dialog/daisy.ink" + ".json" },
            { name: "ditzi.ink", url: "data/dialog/ditzi.ink" + ".json" },
            { name: "ducky.ink", url: "data/dialog/ducky.ink" + ".json" },
            { name: "dwight.ink", url: "data/dialog/dwight.ink" + ".json" },
            { name: "darklord.ink", url: "data/dialog/darklord.ink" + ".json" },
            { name: "feral.ink", url: "data/dialog/feral.ink" + ".json" },
            { name: "fish_guard.ink", url: "data/dialog/fish_guard.ink" + ".json" },
            { name: "fox_thief_1.ink", url: "data/dialog/fox_thief_1.ink" + ".json" },
            { name: "fox_thief_2.ink", url: "data/dialog/fox_thief_2.ink" + ".json" },
            { name: "fox_thief_3.ink", url: "data/dialog/fox_thief_3.ink" + ".json" },
            { name: "fritzi.ink", url: "data/dialog/fritzi.ink" + ".json" },
            { name: "fish_monster.ink", url: "data/dialog/fish_monster.ink" + ".json" },
            { name: "giant_spider.ink", url: "data/dialog/giant_spider.ink" + ".json" },
            { name: "glitzi.ink", url: "data/dialog/glitzi.ink" + ".json" },
            { name: "goblin.ink", url: "data/dialog/goblin.ink" + ".json" },
            { name: "gnome_bear.ink", url: "data/dialog/gnome_bear.ink" + ".json" },
            { name: "gunther.ink", url: "data/dialog/gunther.ink" + ".json" },
            { name: "gregory.ink", url: "data/dialog/gregory.ink" + ".json" },
            { name: "hansi.ink", url: "data/dialog/hansi.ink" + ".json" },
            { name: "hench_cat_1.ink", url: "data/dialog/hench_cat_1.ink" + ".json" },
            { name: "hench_cat_2.ink", url: "data/dialog/hench_cat_2.ink" + ".json" },
            { name: "jezabel.ink", url: "data/dialog/jezabel.ink" + ".json" },
            { name: "king_axalotyl.ink", url: "data/dialog/king_axalotyl.ink" + ".json" },
            { name: "king_knut.ink", url: "data/dialog/king_knut.ink" + ".json" },
            { name: "king_svanson.ink", url: "data/dialog/king_svanson.ink" + ".json" },
            { name: "lars.ink", url: "data/dialog/lars.ink" + ".json" },
            { name: "lisbet.ink", url: "data/dialog/lisbet.ink" + ".json" },
            { name: "maggie.ink", url: "data/dialog/maggie.ink" + ".json" },
            { name: "mother_duck.ink", url: "data/dialog/mother_duck.ink" + ".json" },
            { name: "marjory.ink", url: "data/dialog/marjory.ink" + ".json" },
            { name: "mr_fairy.ink", url: "data/dialog/mr_fairy.ink" + ".json" },
            { name: "nanny.ink", url: "data/dialog/nanny.ink" + ".json" },
            { name: "nobleswan_1.ink", url: "data/dialog/nobleswan_1.ink" + ".json" },
            { name: "nobleswan_2.ink", url: "data/dialog/nobleswan_2.ink" + ".json" },
            { name: "oskar.ink", url: "data/dialog/oskar.ink" + ".json" },
            { name: "ogre_thief.ink", url: "data/dialog/ogre_thief.ink" + ".json" },
            { name: "percy.ink", url: "data/dialog/percy.ink" + ".json" },
            { name: "prince_svan.ink", url: "data/dialog/prince_svan.ink" + ".json" },
            { name: "princess_svandelyne.ink", url: "data/dialog/princess_svandelyne.ink" + ".json" },
            { name: "princess_syllabob.ink", url: "data/dialog/princess_syllabob.ink" + ".json" },
            { name: "queen_grizabella.ink", url: "data/dialog/queen_grizabella.ink" + ".json" },
            { name: "queen_kristine.ink", url: "data/dialog/queen_kristine.ink" + ".json" },
            { name: "queen_svania.ink", url: "data/dialog/queen_svania.ink" + ".json" },
            { name: "queen_moleworm.ink", url: "data/dialog/queen_moleworm.ink" + ".json" },   
            { name: "raymond.ink", url: "data/dialog/raymond.ink" + ".json" },
            { name: "rulf.ink", url: "data/dialog/rulf.ink" + ".json" },
            { name: "roger.ink", url: "data/dialog/roger.ink" + ".json" },
            { name: "rory.ink", url: "data/dialog/rory.ink" + ".json" },
            { name: "spritzi.ink", url: "data/dialog/spritzi.ink" + ".json" },
            { name: "suzie.ink", url: "data/dialog/suzie.ink" + ".json" },
            { name: "susan.ink", url: "data/dialog/susan.ink" + ".json" },
            { name: "stefan.ink", url: "data/dialog/stefan.ink" + ".json" },   
            { name: "tatiana.ink", url: "data/dialog/tatiana.ink" + ".json" },
            { name: "toby.ink", url: "data/dialog/toby.ink" + ".json" },
            { name: "wolf.ink", url: "data/dialog/wolf.ink" + ".json" },
            { name: "weasel.ink", url: "data/dialog/weasel.ink" + ".json" }
        ]

        files = files.concat(characterJsons, characterInks, locations);

        if (files.length) {
            this._preloader = new CNPreloaderScene();
            P3.scene.show(this._preloader);

            const basePath = "./";
            P3.assets.addFiles(files, basePath + "assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this)
            P3.assets.signals.complete.once(this.onLoadingComplete, this);
            P3.assets.load();
        } else {
            this.start();
        }
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        this._preloader.progress = event.progress / 100;
    }

    /**
     * @param {Event} event
     */
    onLoadingComplete(event) {
        P3.assets.signals.progress.detachAll();

        this._preloader.signals.loaded.add(() => this.start());
    }

    start() {
        this._app = new Application();
    }

    onCanvasResize(correct) {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);

            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }
}